import styled from 'styled-components';
import Delete from 'assets/images/invoice/delete.svg';
import NoInvoices from 'assets/images/invoice/no-invoices.svg';

const AddNewItemsBtn = styled.button`
  border: 2px solid ${props => props.theme && props.theme.color.primary};
  border-radius: 4px;
  text-align: center;
  color: ${props => props.theme && props.theme.color.primary};
  font-size: 1em;
  width: 100%;
  padding: 0.5em;
  transition: opacity 0.25s ease-in-out;
  margin: 2em 0 1em;
  background: transparent;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

const CostBlock = styled.div`
  display: flex;
  width: 25%;
  max-width: 100px;
  align-items: flex-end;
  justify-content: flex-end;
  position: relative;
  box-sizing: border-box;
  min-height: 20px;
  bottom: -3px;
  & > * {
    z-index: 1;
    color: ${(p) => p.theme.color.text};
    background-color: ${(p) => p.theme.color.bg_white};;
  }
  & > span {
    padding-left: 0.3em;
    position: relative;
    bottom: -1px;
  }
  & > div {
    ${props =>
    props.edited
      ? 'position: absolute; bottom: 0; right: 0;'
      : 'position: relative; bottom: -2px'};
  }
  input {
    position: relative;
    box-sizing: border-box;
    border: none;
    font-size: 1em;
    outline: none;
    text-align: right;
    &:focus {
      border-radius: 4px;
      text-align: center;
      border: 1px solid
        ${props =>
    props &&
    props.theme &&
    props.theme.color &&
    props.theme.color.primary};
      padding: 0.5em;
      font-size: 16px;
    }
  }
`;

const CreateInvoiceBlock = styled.div`
  height: 100%;
  border-radius: 4px;
  border: solid 1px ${props => props.theme.color.border};
  box-sizing: border-box;
`;

const CreateInvoiceBtn = styled.button`
  background-color: ${props => props.theme.color.primary};
  border-radius: 6px;
  max-width: 270px;
  width: 100%;
  padding: 13px 0;
  font-size: 18px;
  font-weight: 500;
  color: #fff;
  margin: 20px 30px;
  cursor: pointer;
  line-height: 22px;
  &:disabled {
    background-color: ${props => props.theme.color.disabled};
    cursor: default;
  }
`;

const DeleteInvoice = styled.img.attrs({
  src: Delete
})`
  margin-top: 8px;
  height: 20px;
  cursor: pointer;
`;

const DescriptionBlock = styled.div`
  display: flex;
  position: relative;
  margin-bottom: 0;
  margin-top: 6px;
  border-bottom: 2px dotted ${(p) => p.theme.color.border};
  &:after {
    display: block;
    content: '';
    height: 100%;
    width: 2em;
    background: #fff;
    position: absolute;
    left: 100%;
  }
  > div:first-of-type {
    padding-right: 0.5em;
    flex: 1;
    display: inline;
    position: relative;
    box-sizing: border-box;
    bottom: -5px;
    & > span {
      background-color: #fff;
      &:last-of-type {
        padding-right: 0.3em;
      }
    }
  }
`;

const DescriptionNumber = styled.p`
  font-size: 14px;
  text-align: left;
  margin: 0;
  color: ${props => props.theme.color.label};
  margin-top: 2px;
`;

const DescriptionWrapper = styled.div`
  padding-left: 12px;
  box-sizing: border-box;
  width: calc(100% - 20px);
  position: relative;
`;

const EmptyInvoiceList = styled.div`
  text-align: center;
  margin: 0 58px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;

const HeaderTitle = styled.div`
  font-size: 14px;
  color: ${props => props.theme.color.label};
  display: inline-block;
  float: ${props => props.float};
`;

const Invoice = styled.div`
  display: flex;
  margin-top: 1em;
`;

const InvoiceHeader = styled.div`
  padding: 16px 15px 0;
`;

const InvoiceList = styled.div`
  padding: 0px 15px;
  height: calc(100% - 34px - 61px - 48px - 88px);
  overflow: hidden;
`;

const InvoiceListContent = styled.div`
  width: 100%;
  height: 100%;
  padding-right: 15px;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: content-box; /* So the width will be 100% + 17px */
  right: 0px;
  top: 0;
  left: 0;
  bottom: 0;
  /* padding-right: 60px */
  ::-webkit-scrollbar {
    width: 100%;
    display: none;
  }
`;

const NoInvoicesIcon = styled.img.attrs({
  src: NoInvoices
})``;

const NoInvoiceTitle = styled.div`
  font-size: 18px;
  color: ${props => props.theme.color.label};
  margin-top: 25px;
`;

const ProDeoBlock = styled.div`
  padding: 14px 17px 13px 17px;
  border-bottom: 1px solid ${props => props.theme.color.border};
`;

const TotalBlock = styled.div`
  padding: 9px 15px 18px;
  border-bottom: 1px solid ${props => props.theme.color.border};
  border-top: 1px solid ${props => props.theme.color.border};
  & > div {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    border-bottom: 2px dotted ${props => props.theme.color.border};
    & > span {
      background: white;
      position: relative;
      bottom: -3px;
      z-index: 1;
      line-height: 100%;
      padding-right: 0.5em;
      &:last-of-type {
        font-size: 30px;
        font-weight: bold;
        padding: 0 0 0 0.2em;
      }
    }
  }
`;

const WrapperEmpty = styled.div`
  position: relative;
  height: calc(100% - 34px - 61px - 48px - 88px);
  overflow: hidden;
`;

export {
  AddNewItemsBtn,
  CostBlock,
  CreateInvoiceBlock,
  CreateInvoiceBtn,
  DeleteInvoice,
  DescriptionBlock,
  DescriptionNumber,
  DescriptionWrapper,
  EmptyInvoiceList,
  HeaderTitle,
  Invoice,
  InvoiceHeader,
  InvoiceList,
  InvoiceListContent,
  NoInvoicesIcon,
  NoInvoiceTitle,
  ProDeoBlock,
  TotalBlock,
  WrapperEmpty
};
